export const webClientId = '808751182390-khqn62coc4r68a11nle17v0jbk24ns30.apps.googleusercontent.com'